import { createRouter, createWebHistory } from "vue-router";
import ICC from "@/views/DomainControl/ICC.vue";
import IVSE from "@/views/DomainControl/IVSE.vue";
import TAA from "@/views/DomainControl/TAA.vue";
import DUR from "@/views/DomainControl/DUR.vue";
import ADA from "@/views/DomainControl/ADA.vue";
import RWS from "@/views/DomainControl/RWS.vue";
import AWS from "@/views/DomainControl/AWS.vue";
import SbTv from "@/views/DomainControl/SbTv.vue";
import DMC from "@/views/DomainControl/DMC.vue";
import DST from "@/views/DomainControl/DST.vue";
import CST from "@/views/DomainControl/CST.vue";
import BFD from "@/views/DomainControl/BFD.vue";
import IFTF from "@/views/DomainControl/IFTF.vue";
import MAABS from "@/views/DomainControl/MAABS.vue";
import HDC from "@/views/DomainControl/HDC.vue";
import HOME from "@/views/DomainControl/Home.vue";
import ESP32Update from "@/views/DomainControl/ESP32Update.vue";
import DomainControl from "@/views/DomainControl/DomainControl.vue";

const domainControl = [
  {
    path: "/domain-control",
    name: "DomainControl",
    component: DomainControl,
    children: [
      {
        path: "IVSE",
        name: "IVSE",
        component: IVSE, // () => import("../views/DomainControl/ICC.vue"),
      },
      {
        path: "",
        redirect: "/domain-control/Home",
      },
      {
        path: "ICC",
        name: "ICC",
        component: ICC, // () => import("../views/DomainControl/ICC.vue"),
      },
      {
        path: "TAA",
        name: "TAA",
        component: TAA, // () => import("../views/DomainControl/TAA.vue"),
      },
      {
        path: "DUR",
        name: "DUR",
        component: DUR, // () => import("../views/DomainControl/DUR.vue"),
      },
      {
        path: "ADA",
        name: "ADA",
        component: ADA, // () => import("../views/DomainControl/ADA.vue"),
      },
      {
        path: "RWS",
        name: "RWS",
        component: RWS, // () => import("../views/DomainControl/RWS.vue"),
      },
      {
        path: "AWS",
        name: "AWS",
        component: AWS, // () => import("../views/DomainControl/AWS.vue"),
      },
      {
        path: "SbTv",
        name: "SbTv",
        component: SbTv, // () => import("../views/DomainControl/SbTv.vue"),
      },
      {
        path: "DMC",
        name: "DMC",
        component: DMC, // () => import("../views/DomainControl/DMC.vue"),
      },
      {
        path: "DST",
        name: "DST",
        component: DST, // () => import("../views/DomainControl/DST.vue"),
      },
      {
        path: "CST",
        name: "CST",
        component: CST, // () => import("../views/DomainControl/CST.vue"),
      },
      {
        path: "BFD",
        name: "BFD",
        component: BFD, // () => import("../views/DomainControl/BFD.vue"),
      },
      {
        path: "IFTF",
        name: "IFTF",
        component: IFTF, // () => import("../views/DomainControl/IFTF.vue"),
      },
      {
        path: "MAABS",
        name: "MAABS",
        component: MAABS, // () => import("../views/DomainControl/MAABS.vue"),
      },
      {
        path: "HDC",
        name: "HDC",
        component: HDC, // () => import("../views/DomainControl/HDC.vue"),
      },
      {
        path: "Home",
        name: "Home",
        component: HOME, // () => import("../views/DomainControl/Home.vue"),
      },
      // 更新 ESP32 代码
      {
        path: "ESP32Update",
        name: "ESP32Update",
        component: ESP32Update,
      },

      {
        path: "tailwind-test",
        name: "TailwindTest",
        component: () => import("@/components/TailwindTest.vue"),
      },
    ],
  },
];

// 导入其他页面组件

const routes = [
  {
    path: "/",
    redirect: "/domain-control",
  },
  ...domainControl,
  {
    path: "/:catchAll(.*)*",
    component: () => import("../views/ErrorNotFound.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
